module.exports = __webpack_public_path__ + "static/media/Screenshot_2.b1cdcc88.png";